    <!-- [style.width.vw]="width" -->
    <div
    class="container" [ngClass]="typePopup"
    [@showHide]="{ value: animationState, params: { height: height } }"
    (@showHide.start)="onShowHide($event)"
    (@showHide.done)="onShowHide($event)"
>
    <aa-popup-menu-item
        *ngFor="let popupMenuItem of popupMenuItems"
        class="popitem"
        [typePopup]="typePopup"
        [popupMenuItem]="popupMenuItem"
    ></aa-popup-menu-item>
</div>
